export default [
  {
    path: '/quoting/:severType/index',
    name: 'quoting',
    component: () => import('@/views/quoting/index'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/customer/:productType?',
    name: 'quotingCustomer',
    component: () => import('@/views/quoting/attach-customer'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/:severType/underwriting',
    name: 'quotingUnderWriting',
    component: () => import('@/views/quoting/underwriting'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/:severType/quote',
    name: 'quotingQuote',
    component: () => import('@/views/quoting/quote'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
  {
    path: '/quoting/:severType/refer',
    name: 'quotingRefer',
    component: () => import('@/views/quoting/refer'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/information',
    name: 'quotingInformation',
    component: () => import('@/views/quoting/client-info'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/refer/info',
    name: 'quotingQuoteRefer',
    component: () => import('@/views/quoting/quote-refer'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/quote/refer/information',
    name: 'quotingQuoteReferInformation',
    component: () => import('@/views/quoting/quote-refer-information'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/payment',
    name: 'quotingPayment',
    component: () => import('@/views/quoting/payment'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/payment/success',
    name: 'quotingPaymentSuccess',
    component: () => import('@/views/quoting/payment-success'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/quote/save',
    name: 'saveQuoteSuccess',
    component: () => import('@/views/quoting/saveQuoteSuccess'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/send/link',
    name: 'sendLinkSuccess',
    component: () => import('@/views/quoting/sendLinkSuccess'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/referrer/send/payment',
    name: 'quotingReferrerSendPayment',
    component: () => import('@/views/quoting/referrer-quote-payment'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/select/create',
    name: 'quotingSelectCreateType',
    component: () => import('@/views/quoting/select-for-quote'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/disc-upload/:severType',
    name: 'quotingDiscUpload',
    component: () => import('@/views/quoting/disc-upload'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
]
